import React from 'react';
import { PMenuIconProps, useMenuIcon } from './useMenuIcon';

export const EventsIco: React.FC<PMenuIconProps> = (props) => {
  const { currentColor, classes } = useMenuIcon(props);
  return (
    <svg
      className={classes.ico}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.5617 3.5214C22.0098 2.96944 21.2897 2.68131 20.5216 2.68131H18.5296V1.96127C18.5296 1.36126 18.0255 0.857178 17.4255 0.857178H16.6335C16.0335 0.857178 15.5295 1.36126 15.5295 1.96127V2.68131H8.47389V1.96127C8.47389 1.36126 7.96981 0.857178 7.36981 0.857178H6.57781C5.97781 0.857178 5.47373 1.36126 5.47373 1.96127V2.68131H3.50564C1.89765 2.68131 0.601562 3.97723 0.601562 5.5854V20.2734C0.601562 21.8814 1.89747 23.1775 3.50564 23.1775H16.6336C17.4256 23.1775 18.2177 22.8415 18.7696 22.2896L22.4897 18.5695C23.0657 17.9935 23.3776 17.2255 23.3776 16.4335V5.60949C23.4019 4.79336 23.0898 4.07331 22.5618 3.52135L22.5617 3.5214ZM2.40173 20.2494V8.5134H21.6017V15.8574H18.1457C17.0177 15.8574 16.1056 16.7695 16.1056 17.8975L16.1058 21.3534H3.50577C2.90577 21.3534 2.40168 20.8495 2.40168 20.2495L2.40173 20.2494Z"
        fill={currentColor}
      />
    </svg>
  );
};
